import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../Hooks/useToggle';
import heroThumb from '../../assets/images/partner-ship-image.webp';
import BackToTop from '../BackToTop';
import FooterHomeThree from '../Footer/FooterHomeThree';
import PartnershipForm from '../Forms/PartnershipForm';
import HeaderNews from '../Header/HeaderNews';
import HeroNews from '../Header/HeroNews';
import Drawer from '../Mobile/Drawer';
import ServicesHomeEight from './ServicesHomeEight';
import WorkPartHomeEight from './WorkPartHomeEight';

function Partnership() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Refer businesses to OTO and earn a commission every month for up to 24 months. For accountants, IT installers and consultants in Rwanda."
                />
                <meta property="og:image" content={heroThumb} />
                <link rel="image_src" href={heroThumb} />
                <title>OTO Partner Programme: Monthly Commissions | OTO by Kapp</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <main>
                <HeroNews
                    title="Join Our Partnership Program"
                    breadcrumb={[
                        { link: '/', title: 'Home' },
                        { link: '/partnership', title: 'Partnership Program' },
                    ]}
                />

                <div className="container pt-90 pb-90">
                    <h2 className="mb-3">
                        Partner with OTO and Boost Your Earnings <br /> with Our Leading SaaS Apps
                    </h2>
                    <p style={{ fontSize: '18px', lineHeight: '29px' }}>
                        Are you looking for a lucrative partnership opportunity that offers
                        recurring monthly commissions and great earning potential? Look no further!
                        OTO is excited to invite you to join our commission-based partnership
                        program and become part of our success story.
                    </p>
                    <hr />
                    <p>
                        As OTO partner, you will have the opportunity to earn generous commissions
                        on every sale of our innovative software suite for inventory management,
                        finance, POS, and hotel management. What's more, our partnership program
                        offers recurring monthly commissions for up to 24 months for eligible sales,
                        providing you with ongoing earnings long after the initial sale.
                    </p>
                </div>

                <ServicesHomeEight />
                <WorkPartHomeEight />

                <div>
                    <div className="container">
                        <div className="text-center col-md-7 col-10 mx-auto">
                            <h2 className="title mb-3">Apply Today !</h2>
                            <p>
                                Fill in the form below, to join our partnership program and boost
                                your earnings with our leading SaaS apps and start earning with OTO
                                today!
                            </p>
                        </div>
                        <PartnershipForm />
                    </div>
                </div>
            </main>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Partnership;
